<template>
  <v-dialog v-model="dialog" max-width="560" persistent>
    <v-card>
      <v-card-title class="headline primary white--text">
        {{ title }}
      </v-card-title>

      <v-card-text class="pt-5">
        <div class="mb-4">
          {{ message }}<strong class="ml-1">"{{ matchText }}"</strong>
        </div>

        <v-text-field
          v-model="typedText"
          :label="inputLabel"
          outlined
          dense
          :error-messages="inputError"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />

        <v-btn outlined color="error" @click="handleCancel">
          {{ cancelButtonText }}
        </v-btn>

        <v-btn
          color="primary"
          :disabled="!isMatched"
          :loading="confirmBtnLoading"
          @click="handleConfirm"
        >
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TitleMatchConfirmationDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    matchText: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Confirmation",
    },
    message: {
      type: String,
      default: "To confirm, type the exact text",
    },
    inputLabel: {
      type: String,
      default: "Type text",
    },
    confirmButtonText: {
      type: String,
      default: "Confirm",
    },
    cancelButtonText: {
      type: String,
      default: "Cancel",
    },
    confirmBtnLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      typedText: "",
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    isMatched() {
      return !!this.matchText && this.typedText === this.matchText;
    },

    inputError() {
      if (!this.typedText) return [];

      return this.typedText === this.matchText
        ? []
        : [this.$vuetify.lang.t('$vuetify.subscription_plans.messages.title_not_match')];
    },
  },

  watch: {
    value(val) {
      if (!val) {
        this.typedText = "";
      }
    },
  },

  methods: {
    handleCancel() {
      this.typedText = "";
      this.$emit("onCancel");
      this.$emit("input", false);
    },

    handleConfirm() {
      if (!this.isMatched) return;
      this.$emit("onConfirmation");
    },
  },
};
</script>